module.exports = __webpack_public_path__ + "img/project4_5.jpg.9bb081e5.webp";